const TOKEN_KEY = 'access_token'
const USER_DETAILS_KEY = 'user'
const CURRENT_TEAM_KEY = 'current_team'
const APP_STATE_KEY = 'app_state'
const LOCALE_KEY = 'locale'
const DEFAULT_LOCALE = 'en-US'
const VERIFICATION_PENDING_KEY = 'verification_pending'
const FEATURES_KEY = 'features'
const VERIFICATION_STATUS = {
  PENDING_EMAIL_VERIFICATION: 'pending_email_verification',
  FULLY_AUTHENTICATED: 'fully_authenticated',
}
const USER_ONBOARDED = 'user_onboarded'

export {
  TOKEN_KEY,
  USER_DETAILS_KEY,
  CURRENT_TEAM_KEY,
  LOCALE_KEY,
  DEFAULT_LOCALE,
  VERIFICATION_STATUS,
  VERIFICATION_PENDING_KEY,
  APP_STATE_KEY,
  FEATURES_KEY,
  USER_ONBOARDED,
}
